import { Phone, MessageCircle } from "lucide-react";
import { COMPANY } from "@/lib/api";

export default function StickyCallBar() {
  return (
    <div
      data-testid="sticky-call-bar"
      className="fixed bottom-0 inset-x-0 z-50 md:hidden grid grid-cols-2 shadow-[0_-4px_16px_rgba(0,0,0,0.15)]"
    >
      <a
        href={`tel:${COMPANY.phone}`}
        data-testid="sticky-call-button"
        className="flex items-center justify-center gap-2 bg-[#B01116] text-white font-accent font-bold text-sm py-4 active:bg-[#8A0D11]"
      >
        <Phone className="h-4 w-4" />
        Call Now
      </a>
      <a
        href={`https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(
          "Hi Gold Mind Business, I'd like to discuss growth for my business."
        )}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-whatsapp-button"
        className="flex items-center justify-center gap-2 bg-[#25D366] text-white font-accent font-bold text-sm py-4 active:brightness-90"
      >
        <MessageCircle className="h-4 w-4" />
        WhatsApp
      </a>
    </div>
  );
}
